import { Navigate, useLocation } from '../router';
import type { ReactNode } from 'react';

import { useAuth } from '../auth';
import { Brand } from './Brand';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { account, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="screen-loader"><Brand /><span className="loading-dot" /></div>;
  if (!account) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}
